export default "__VITE_ASSET__BNbxSUQj__";